import { render, staticRenderFns } from "./shipmentAdd.vue?vue&type=template&id=00a4e01a&scoped=true"
import script from "./shipmentAdd.vue?vue&type=script&lang=js"
export * from "./shipmentAdd.vue?vue&type=script&lang=js"
import style0 from "./shipmentAdd.vue?vue&type=style&index=0&id=00a4e01a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4e01a",
  null
  
)

export default component.exports